<ng-container [formGroup]="subFormGroup">
  <div class="date-range-form" #daterangeform>
    <div class="form-line-normal" #rangePicker>
      <div class="row no-gutters c-pointer" style="display: flex">
        <div
          class="col-6 form-divider-right pos-r form-placeholder form-placeholder-left-icon form-placeholder-narrow js-placeholder-block is-active"
          style="flex: 0 0 50%">
          <div class="form-icon text-danger">
            <app-icon name="calendarStart" width="25px" height="25px" style="margin-left: -10px" />
          </div>
          <input
            data-test="startDate"
            type="text"
            formControlName="startDate"
            id="startDate"
            (focus)="pickerState = datePickerState.START; hoveredElement = 1"
            (click)="pickerState = datePickerState.START; hoveredElement = 1"
            class="c-pointer form-input form-input-icon-left js-calendar-range js-calendar-from"
            [class.hovered]="hoveredElement === 1"
            readonly="readonly" />
          <label class="form-label" for="startDate">{{
            'ALPINSKIHIRE.shopSearch.formStartDate' | alpitranslate
          }}</label>
        </div>
        <div
          class="col-6 pos-r form-placeholder form-placeholder-narrow form-placeholder-right-icon form-placeholder-narrow-right is-active"
          style="flex: 0 0 50%">
          <div class="form-icon form-icon-right text-danger">
            <app-icon name="calendarEnd" width="25px" height="25px" style="margin-right: -10px" />
          </div>
          <input
            data-test="endDate"
            id="endDate"
            type="text"
            formControlName="endDate"
            (focus)="pickerState = datePickerState.END; hoveredElement = 2"
            (click)="pickerState = datePickerState.END; hoveredElement = 2"
            class="c-pointer form-input text-right form-input-icon-right"
            style="text-align: end"
            [class.hovered]="hoveredElement === 2"
            readonly="readonly" />
          <label class="form-label" for="endDate">{{
            'ALPINSKIHIRE.shopSearch.formEndDate' | alpitranslate
          }}</label>
        </div>
      </div>
    </div>
    <!-- now injected here by createComponent logic -->
    <!-- <app-rangepicker *ngIf="pickerState !== datePickerState.HIDE" [initWith]="pickerState"
      [fromDate]="{year: fromDate.year, month: fromDate.month, day: fromDate.day}"
      [toDate]="{year: toDate.year, month: toDate.month, day: toDate.day}" (hoveredStart)="hoverUpdateStart($event)"
      (hoveredEnd)="hoverUpdateEnd($event)" (selectedRange)="onDateSelection($event)" @collapsible></app-rangepicker> -->
  </div>
</ng-container>
